import { render, staticRenderFns } from "./PicSelector.vue?vue&type=template&id=28983f7a&scoped=true&"
import script from "./PicSelector.vue?vue&type=script&lang=js&"
export * from "./PicSelector.vue?vue&type=script&lang=js&"
import style0 from "./PicSelector.vue?vue&type=style&index=0&id=28983f7a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28983f7a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VImg,VRow})
